/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { PublicFilterNotificationRuleAssetScopeConditionDto } from './PublicFilterNotificationRuleAssetScopeConditionDto';
import type { PublicReferenceByIdOrNameDto } from './PublicReferenceByIdOrNameDto';

export type PublicDataProductFilterNotificationRuleAssetScopeConditionDto = (PublicFilterNotificationRuleAssetScopeConditionDto & {
    /**
     * Data product references (id and/or name). Name-only references fail if multiple data products share that name.
     */
    dataProducts?: Array<PublicReferenceByIdOrNameDto>;
    /**
     * Operator of the condition
     */
    operator?: PublicDataProductFilterNotificationRuleAssetScopeConditionDto.operator;
} & {
    /**
     * Data product references (id and/or name). Name-only references fail if multiple data products share that name.
     */
    dataProducts: Array<PublicReferenceByIdOrNameDto>;
    /**
     * Operator of the condition
     */
    operator: PublicDataProductFilterNotificationRuleAssetScopeConditionDto.operator;
});

export namespace PublicDataProductFilterNotificationRuleAssetScopeConditionDto {

    /**
     * Operator of the condition
     */
    export enum operator {
        IS = 'IS',
        IS_NOT = 'IS_NOT',
    }


}
